import { jsx as _jsx } from "react/jsx-runtime";
import IconButtonWithPopupMenu from "../../../components/molecules/IconButtonWithPopupMenu/IconButtonWithPopupMenu.molecule.js";
import { menuActionButtonSlotProps } from "./MenuActionButton.slots.js";
export const MenuActionButtonMoleculeComponent = ({ slotProps, ...props }) => (_jsx(IconButtonWithPopupMenu, { ...props, anchorOrigin: { vertical: "top", horizontal: "left" }, transformOrigin: { vertical: "bottom", horizontal: "left" }, slotProps: {
        ...menuActionButtonSlotProps,
        ...slotProps,
        menu: { ...menuActionButtonSlotProps.menu, ...slotProps?.menu },
    } }));
export default MenuActionButtonMoleculeComponent;
